module.exports = __webpack_public_path__ + "static/media/skip black.c2b9314f.svg";